var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryFactoryIconBplam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 152v295.1c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32v-384c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32v160l139.1-92.24C315.1 121.6 336 133.1 336 152V223.1l139.1-92.24C491.1 121.6 512 133.1 512 152z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryFactoryIconBplam);
export default __webpack_public_path__ + "static/media/Industry_factory_icon_bplam.b0cfdf1d59c59c491a2cf25a279567e1.svg";
export { ForwardRef as ReactComponent };